/* eslint-disable no-restricted-globals */
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState, useRef } from 'react';
import {
  useNavigate,
  useLocation,
  useSearchParams,
  Link,
} from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import Logo from './Logo';
import { Logger } from 'src/latest/src/services';
import { AppConstant, extractAuthorities } from 'src/latest/src';
import { getAccessToken } from 'src/latest/src/auth/authStore';
import { useIsMobile } from 'src/latest/src/hooks';
import Storage from '../../latest/src/utils/Storage';

import {
  deepClone,
  handleQuestionRender,
  isEmptyObject,
  prepareResponseData,
  stringToObject,
  getFilterByKey,
} from '../../legacy/utils/helpers';
import {
  checkUserCredentialsExists,
  fetchUserInfoV1,
  selfOnboardingApi,
} from '../../api/user';
import { authUser } from '../../redux/modules/authentication';
import { setFlashNotification } from '../../redux/modules/flashNotification';
import { UserServiceSection } from '../../latest/src/constants/AppServerConfig';
import ClientOnboardingModal from 'src/latest/src/containers/QuestionnaireParent/components/ClientOnboardingModal/ClientOnboardingModal';
import { evaluateSubmitButtonStatus } from 'src/latest/src/utils/questionnaireSubmitButtonStatus';
import {
  fetchQuestionnaireMetaData,
  fetchQuestions,
  saveResponses,
  updateContinueButton,
  updateQuestionnaireConfig,
  setIsCompleted,
  setQuestionnaireData,
  updateSignPadStatus,
} from '../../redux/actions/questionnaireActions';
import QuestionnairePage from '../QuestionnaireParent/QuestionnairePage';
import AppButton from './QuestionOptionsLibrary/components/Button/Button';
import './questionnaire.scss';
import {
  PageUniqueKeys,
  QuestionnaireGroupType,
} from 'src/containers/QuestionnaireParent/QuestionnaireEnum';
import { LoadingIndicator, Typography } from 'src/latest/src/components';
import { clearModalContent } from 'src/redux/modules/modalEvent';

type Props = {
  fromModal?: Boolean,
  fromEditProfile?: Boolean,
  questionnaireData?: Array<Object>,
  onResponseSaved?: any,
  hideProgressBar?: boolean,
};

export default function QuestionnaireParentContainer({
  fromModal = false,
  fromEditProfile = false,
  questionnaireData = null,
  onResponseSaved,
  hideProgressBar,
}: Props): React$Element<any> {
  const [searchParams] = useSearchParams();
  const fetchQuestionnaire = searchParams.get('fetchQuestionnaire');
  const { poweredByI2ILogo, tenantBackgroundColor } = useSelector(
    state => state?.configuration,
  );
  const {
    isCompleted,
    currentPage,
    currentQuestions,
    isContinueButtonDisabled,
    direction,
    currentCategory,
    header,
    progress: questionnaireProgress,
    loading: questionnaireLoading,
    questionnaireSessionId: sessionId,
  } = useSelector(state => state?.questionnaireData?.currentConfig);
  const {
    show_match_score_btn: showMatchScoreBtn,
    enhanced_information: therapyInfo,
    questionnaire_group: questionnaireGroup,
    user_id: userId,
    combined_filters: combinedFilters,
  } = useSelector(state => state?.questionnaireData?.initialMetadata);
  const { isAuthed, loggedInUser } = useSelector(
    state => state?.authentication,
  );
  const history = useNavigate();
  const locationG = useLocation();
  const dispatch = useDispatch();
  const isPracticeSummaryInfoPage =
    currentPage?.unique_key === PageUniqueKeys?.practiceSummaryInformationPage;
  const [locationKeys, setLocationKeys] = useState([]);
  const [isFileTypeInvalid, setIsFileTypeInvalid] = useState(false);
  const [buttonLabel, setButtonLabel] = useState(
    isPracticeSummaryInfoPage
      ? 'Start My Profile'
      : fromModal
      ? 'Save Changes'
      : 'Continue',
  );
  const [
    hasContinueButtonStatusEvaluatedBefore,
    setHasContinueButtonStatusEvaluatedBefore,
  ] = useState(false);
  const [hasNegativeResponse, setHasNegativeResponse] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [isOnboardingLoading, setisOnboardingLoading] = useState(false);
  const pageUniqueKey = locationG.state?.state?.pageKey;
  const isFromMobile = useIsMobile();
  const [pageMetadata, setPageMetadata] = useState({});
  const showLocationModal = useSelector(
    state => state?.questionnaireData?.initialMetadata?.show_location_modal,
  );
  const [
    clientOnboardingModalOnboardingVisibility,
    setClientOnboardingModalOnboardingVisibility,
  ] = useState(false);
  const isProfilePicturePage =
    currentPage?.unique_key === PageUniqueKeys.profilePicturePage;
  const userHasProfilePicture = useSelector(
    (state: any) =>
      state?.onboarding?.userToBeOnboarded?.profile_pic?.length > 0,
  );
  const [isMatchAssistance, setIsMatchAssistance] = useState(false);
  const [stripeHasCard, setStripeHasCard] = useState(null);
  const [isStripeCardFormValid, setIsStripeCardFormValid] = useState(false);
  const [isStripeProcessing, setIsStripeProcessing] = useState(false);
  const prevStripeHasCardRef = useRef(false);
  const initialStripeCardStateRef = useRef(null); // Tracks initial card state when arriving at page
  const stripePaymentRef = useRef(null);
  const hasVisitedStripePageInSession = useRef(false);
  const loggedInUserPTFlow = JSON.parse(localStorage.getItem('loggedInUser'));
  const accessToken: string = getAccessToken();
  const loggedInUserID: string =
    loggedInUserPTFlow?.id?.length > 0
      ? loggedInUserPTFlow?.id
      : loggedInUser?.id;

  const isSelfOnboardingPage = [
    'bbgSelfInvitationSelfMatchingClientPgV1',
    'selfInvitationSelfMatchingClientPgV1',
  ].includes(currentPage?.unique_key);

  // const btnWhy = document.querySelector(".btn-why");
  // TODO: need to remove it later, as checkin checkout functionality is not there now
  // later when we start vedio calls, we can evaluate and remove it if not needed

  useEffect(async () => {
    Storage.removeItem('isCompleted');

    if (!fromModal) {
      const isOptOut = await redirectToOptOutPage();

      if (isOptOut) {
        history('/therapy/opt-out');
      } else if (fetchQuestionnaire) {
        await initData(pageUniqueKey);
      }
    }
  }, []);

  const redirectToOptOutPage = async () => {
    if (Storage.getItem('opt-out') !== 'completed') {
      return loggedInUser?.metadata
        ? loggedInUser?.metadata['opt-out-enable'] === 'true'
        : false;
    } else {
      return false;
    }
  };

  const hideGoBackButtonForPages = [
    questionnaireGroup?.type ===
      QuestionnaireGroupType.SELF_MATCHING_CLIENT_INTAKE &&
      clientOnboardingModalOnboardingVisibility &&
      'clinicialAvailabilitySelfMatchingClientPgV1',
  ];

  const shouldHideGoBackButton = !hideGoBackButtonForPages.includes(
    currentPage?.unique_key,
  );

  const hideContinueButtonForPages = [
    'clientOnboardingBySchedulerWelcomePage',
    // 'selfInvitationSelfMatchingClientPgV1',
    'enhancedEsignForSelfMatchingClientAdultPgV1',
    'therapistOnboardingBySchedulerCompletionWelcomeScreenV1',
    'intakeCompletionLastPage',
    'schedulerIntakeCompletionWelcomeScreenV1',
    'PracticeAdminIntakeCompletionWelcomeScreenV1',
    !loggedInUser?.id && 'clinicialAvailabilitySelfMatchingClientPgV1',
    'clientOnboardingWelcomePage',
    'intakeCompletionWelcomeScreen',
    'intakeCompletionWelcomeScreenDirectoryV1',
    'intakeCompletionWelcomeScreenVidaV1',
    'publicClientCredentialSelfMatchingClientPgV1',
  ];

  const stripedPages = [
    PageUniqueKeys.stripeCreditCardPageV1,
    PageUniqueKeys.stripeCreditCardPage,
    PageUniqueKeys.stripeCreditCardPageDirectoryV1,
  ];

  const shouldHideContinueButton =
    hideContinueButtonForPages.includes(currentPage?.unique_key) ||
    (loggedInUser?.user_type?.includes('THERAPIST') &&
      currentPage?.unique_key?.includes('eSignConsentPagePerClinician'));

  // we're hiding comman quesionnaire continue button in all upload consent document pages because its not managable to handle the required conditions if we use comman continue button, so we have made another continue button for upload consent document component.

  // for modal questions - conditional rendering
  useEffect(() => {
    if (questionnaireData && isAuthed) initData();
  }, [questionnaireData]);

  useEffect(() => {
    if (location.action === 'PUSH') {
      setLocationKeys([location.key]);
    } else if (location.action === 'POP') {
      if (locationKeys[1] === location.key) {
        setLocationKeys(([_, ...keys]) => keys);
        // Handle forward event
        dispatch(updateQuestionnaireConfig());
      } else {
        setLocationKeys(keys => [location.key, ...keys]);

        if (questionnaireGroup?.type?.includes('CHECKIN')) {
          history('/therapy/client');
        }

        // Handle back event
        dispatch(updateQuestionnaireConfig(null, 'backward'));
      }
    }
  }, [locationKeys]);

  const initData = async pageUniqueKey => {
    if (!fromModal) {
      await dispatch(setIsCompleted(false));
      await dispatch(fetchQuestionnaireMetaData(true, pageUniqueKey));
    } else {
      try {
        await dispatch(setQuestionnaireData(questionnaireData));
      } catch (e) {
        Logger.log('Questionnaire Parent', e);
      }
    }
  };

  const checkCredentialExists = async () => {
    try {
      await checkUserCredentialsExists(loggedInUserID);

      return false;
    } catch (error) {
      Logger.error('Error while checking Credentials', error);

      return error?.response?.status === 404;
    }
  };

  const handleOnclick = async (updatedChoices?: any) => {
    const choiceMetadata = currentQuestions[0]?.choices[0]?.metadata || {};

    if (
      currentPage.unique_key?.toLowerCase()?.includes('esign') && // esign screen
      choiceMetadata.signed === 'false' // not signed yet
    ) {
      dispatch(updateSignPadStatus(true)); // open signature pad
    } else {
      let questions = deepClone(currentQuestions);

      if (questions && questions.length !== 0) {
        questions = questions.map(question => {
          const shouldRender = handleQuestionRender(question, questions);

          if (!shouldRender) {
            return updateHiddenQuestion(question);
          } else {
            return question;
          }
        });

        const response = prepareResponseData(questions, updatedChoices);

        const hasChangedResponses = true;

        if (
          questionnaireGroup?.type ===
          QuestionnaireGroupType.INDIVIDUAL_CLIENT_CHECKOUT
        ) {
          // return only the questions with negative feedback but except the first question
          const negativeFeedbacks = questions.filter(
            (q, index) =>
              index !== 0 &&
              q?.metadata?.question_type === 'customslider' &&
              q?.choices[0]?.value < -66,
          );

          if (negativeFeedbacks.length >= 1) setHasNegativeResponse(true);
        }

        dispatch(
          saveResponses({
            sessionId,
            categoryId: currentCategory?.id,
            pageId: currentPage?.id,
            responses: response,
            hasChangedResponses,
            responseCallback,
          }),
        );

        if (isMatchAssistance) {
          dispatch(clearModalContent());
        }
      }
    }
  };

  const responseCallback = () => {
    // if (fromModal) {
    if (onResponseSaved) onResponseSaved(currentQuestions);
    // }
  };

  useEffect(() => {
    setTimeout(async () => {
      if (isCompleted === true && !fromModal) {
        if (questionnaireGroup?.type?.toLowerCase()?.includes('intake')) {
          // call the user service to get updated data after questionnaire intake
          // https://app.clickup.com/t/36077897/DEV-2775

          fetchUserInfoV1(UserServiceSection.profile_display, 'medium').then(myInfo => {
            const role = myInfo.user_type?.includes('THERAPIST')
              ? 'therapist'
              : myInfo.user_type?.includes('SCHEDULER')
              ? 'scheduler'
              : myInfo.user_type?.includes('PRACTICE_ADMIN')
              ? 'practice_admin'
              : 'client';

            Storage.setItem('user_type', myInfo.user_type);
            if (myInfo) dispatch(authUser({ ...myInfo, userRole: role })); // update user's redux store
          });
        }

        if (
          questionnaireGroup?.type ===
            QuestionnaireGroupType.INDIVIDUAL_CLIENT_CHECKIN &&
          fetchQuestionnaire
        ) {
          history('/teletherapy/waiting-room');

          return;
        } else if (
          questionnaireGroup?.type ===
            QuestionnaireGroupType.INDIVIDUAL_CLIENT_CHECKOUT &&
          hasNegativeResponse &&
          (localStorage.getItem('lastSessionId') ||
            therapyInfo?.therapySessionId)
        ) {
          history('/request-rematch', {
            therapistName:
              localStorage.getItem('lastTherapistName') ||
              therapyInfo?.fullName ||
              'last therapist', // there is no way
            matchType: 'INDIVIDUAL',
            sessionId:
              localStorage.getItem('lastSessionId') ||
              therapyInfo?.therapySessionId,
          });
        }

        if (
          questionnaireGroup?.type ===
          QuestionnaireGroupType.SELF_MATCHING_CLIENT_INTAKE
        ) {
          if (pageMetadata?.pre_onboarded_user_last_page === 'true') {
            history('/therapy/clinician-availability');
          } else {
            if (
              extractAuthorities(accessToken).includes('PUBLIC_CLIENT') &&
              (await checkCredentialExists())
            ) {
              history('/reset-credentials', { replace: true });
            } else {
              history('/meeting-info', { replace: true });
            }
          }
        } else {
          Logger.log(
            'Questionnaire Parent container (useEffect isCompleted): Redirecting to /',
          );

          // as the role wise dashboard will be determined by the main component
          history('/');
        }
      }
    }, 100);
  }, [isCompleted]);

  /** fetch questions on page change **/
  useEffect(() => {
    const pageMetadata =
      (currentPage?.metadata && stringToObject(currentPage?.metadata)) || {};

    setPageMetadata(pageMetadata);

    if (currentPage?.id && !fromModal)
      dispatch(fetchQuestions(currentPage.id, sessionId, direction));
  }, [currentPage?.id]);

  // update the value of the hidden questions
  const updateHiddenQuestion = (question: any) => {
    const hiddenQuestion = deepClone(question);

    // prepare the updated question
    hiddenQuestion.choices = hiddenQuestion.choices.map(choice => {
      if (choice.selected || choice.value) {
        choice.value = null;
        choice.selected = false;
      }

      return choice;
    });

    return hiddenQuestion;
  };

  useEffect(() => {
    if (currentQuestions && currentQuestions.length !== 0) {
      const choiceMetadata = currentQuestions[0]?.choices[0]?.metadata || {};

      if (window.location.pathname.includes('/profile/')) {
        setButtonLabel('Save Changes');
      } else if (
        currentPage?.unique_key ===
        PageUniqueKeys.practiceSummaryInformationPage
      ) {
        setButtonLabel('Start My Profile');
      } else if (
        currentPage?.unique_key?.toLowerCase()?.includes('esign') && // esign screen
        choiceMetadata.signed === 'false' // not signed yet
      ) {
        setButtonLabel('Sign');
      } else {
        setButtonLabel('Continue');
      }

      if (hasContinueButtonStatusEvaluatedBefore || !fromEditProfile) {
        const _continueButtonStatus = evaluateSubmitButtonStatus(
          currentQuestions,
          currentPage,
        );

        dispatch(
          updateContinueButton({
            buttonStatus: _continueButtonStatus ? 'enabled' : 'disabled',
          }),
        );
      } else {
        setHasContinueButtonStatusEvaluatedBefore(true);
      }

      if (!clientOnboardingModalOnboardingVisibility) {
        setClientOnboardingModalOnboardingVisibility(true);
      }
    }
  }, [currentQuestions]);

  useEffect(() => {
    const isOnStripePage =
      currentPage?.unique_key === PageUniqueKeys.stripeCreditCardPageV1 ||
      currentPage?.unique_key === PageUniqueKeys.stripeCreditCardPage ||
      currentPage?.unique_key ===
        PageUniqueKeys.stripeCreditCardPageDirectoryV1;

    if (isOnStripePage) {
      if (initialStripeCardStateRef.current === null) {
        if (stripeHasCard !== null) {
          initialStripeCardStateRef.current = stripeHasCard;
          prevStripeHasCardRef.current = stripeHasCard;
          hasVisitedStripePageInSession.current = true;
        }

        return;
      }

      if (
        stripeHasCard &&
        !prevStripeHasCardRef.current &&
        hasVisitedStripePageInSession.current === true
      ) {
        const timer = setTimeout(() => {
          handleOnclick();
        }, 300);

        return () => clearTimeout(timer);
      }

      prevStripeHasCardRef.current = stripeHasCard;
    }
  }, [currentPage?.unique_key, stripeHasCard]);

  // Reset stripe state when leaving the Stripe credit card page
  useEffect(() => {
    if (
      currentPage?.unique_key !== PageUniqueKeys.stripeCreditCardPageV1 &&
      currentPage?.unique_key !== PageUniqueKeys.stripeCreditCardPage &&
      currentPage?.unique_key !== PageUniqueKeys.stripeCreditCardPageDirectoryV1
    ) {
      prevStripeHasCardRef.current = false;
      initialStripeCardStateRef.current = null;
      setStripeHasCard(null);
      setIsStripeProcessing(false);
    }
  }, [currentPage?.unique_key]);

  const transformOnboardingResponseData = (response: any) => {
    const flatData: any = {};

    // Map question keys to field names
    const keyMappings: any = {
      selfInvitationSelfMatchingClientEmailQuestionV1: 'email',
      selfInvitationSelfMatchingClientPhoneNumberQuestionV1: 'phone_no',
      selfInvitationSelfMatchingFirstNameQuestionV1: 'first_name',
      selfInvitationSelfMatchingLastNameQuestionV1: 'last_name',
      selfInvitationSelfMatchingDateOfBirthQuestionV1: 'birth_date',
    };

    // Transform nested structure to flat structure
    Object.keys(response).forEach(key => {
      if (typeof response[key] === 'object' && !Array.isArray(response[key])) {
        const questionKey = Object.keys(response[key])[0];
        const fieldName = keyMappings[questionKey];

        if (
          fieldName &&
          response[key][questionKey] &&
          Array.isArray(response[key][questionKey])
        ) {
          const choice = response[key][questionKey][0];

          if (choice && choice.value !== undefined) {
            flatData[fieldName] = choice.value;
          }
        }
      }
    });

    return flatData;
  };

  const handleOnboardingSubmit = async (updatedChoices?: any) => {
    try {
      setisOnboardingLoading(true);
      const questions = deepClone(currentQuestions);

      if (questions && questions.length !== 0) {
        const response = prepareResponseData(questions, updatedChoices);

        // Transform response to flat format matching SelfOnboarding API
        const transformedData = deepClone(
          transformOnboardingResponseData(response),
        );

        // Get user ID and age range for API call
        const selfUserId = userId || localStorage.getItem('self-user-id');
        const storedAgeRange = localStorage.getItem('age_range');
        const filtersArray = combinedFilters?.filters;
        const ageGroupFilter =
          filtersArray && getFilterByKey(filtersArray, 'ageGroup');
        const ageRange =
          (ageGroupFilter &&
            ageGroupFilter?.filter_selection_data[0]?.metadata) ||
          storedAgeRange;

        // Map questionnaire response data to Onboarding API format
        const onboardingData = {
          ...transformedData,
          user_type: ['CLIENT'],
          user_id: selfUserId,
          age_range: ageRange,
        };
        const emailField = transformedData?.email || '';

        await selfOnboardingApi(
          onboardingData,
          new URLSearchParams(searchParams),
        );

        dispatch(
          setFlashNotification({
            message:
              'Important! You need to finish verifying your email to reserve your appointment time. The appointment time cannot be guaranteed until registration is completed.',
            duration: 14000,
          }),
        );
        Storage.setItem('self-email', emailField);
        setisOnboardingLoading(false);

        history(`/verify-onboarding`, { state: { email: emailField } }); // Navigate to show display message page
      }
    } catch (err) {
      setisOnboardingLoading(false);
      const message =
        err?.response?.data?.message || 'Failed to send verification link';

      dispatch(
        setFlashNotification({
          message,
          isError: true,
          duration: 9000,
        }),
      );
    }
  };

  const goBack = () => {
    dispatch(updateQuestionnaireConfig(null, 'backward'));

    if (
      questionnaireProgress?.currentPageNumber === 1 &&
      loggedInUser?.metadata &&
      loggedInUser?.metadata['opt-out-enable'] === 'true'
    ) {
      history('/therapy/opt-out'); // show optout page on back button click on first page
    }
  };

  const esignPages = currentPage?.unique_key?.toLowerCase()?.includes('esign');

  return (
    <div
      style={{
        backgroundColor:
          tenantBackgroundColor || AppConstant.defaultAppBackgroundColor,
      }}
      className={`questionnaire ${
        currentPage?.name === 'intakeCompletionWelcomeScreen' && 'pad-zero'
      }`}
    >
      {header?.visible && !hideProgressBar && (
        <div className="survey-progress-base">
          <div
            className="survey-progress"
            style={{ width: questionnaireProgress?.progress + '%' }}
          />
        </div>
      )}
      {!currentQuestions || currentQuestions.length === 0 ? (
        <LoadingIndicator loading={true} style={{ position: 'fixed' }} />
      ) : (
        <div className="d-flex flex-column justify-content-center ">
          <div
            className="session-questionnaire-container min-vh-85 "
            style={{
              marginBottom:
                isFromMobile &&
                showMatchScoreBtn &&
                currentPage.unique_key ===
                  'clinicialAvailabilitySelfMatchingClientPgV1'
                  ? '48px'
                  : '0px',
            }}
          >
            <div className="session-questionnaire">
              <QuestionnairePage
                currentPage={currentPage}
                fromEditProfile={fromEditProfile}
                setUploading={setUploading}
                isFileTypeInvalid={isFileTypeInvalid}
                setIsFileTypeInvalid={setIsFileTypeInvalid}
                handleOnclick={handleOnclick}
                setIsMatchAssistance={setIsMatchAssistance}
                onStripeCardStatusChange={setStripeHasCard}
                onStripeCardFormValidationChange={setIsStripeCardFormValid}
                onStripeProcessingChange={setIsStripeProcessing}
                stripePaymentRef={stripePaymentRef}
                isStripeProcessing={isStripeProcessing}
              />
              {
                <div
                  className={`submitContainer ${
                    esignPages ? 'submitContainer-mb' : ''
                  }`}
                >
                  {/* Show this loaded when there is no page */}
                  {(!currentPage || isEmptyObject(currentPage)) && (
                    <div className="question-loader">
                      <Spinner
                        animation="border"
                        role="status"
                        className="m-auto"
                      />
                    </div>
                  )}
                  {shouldHideContinueButton
                    ? ''
                    : !isEmptyObject(currentPage) && (
                        <div
                          className={`${
                            esignPages ? 'main-fixed-container-mobile' : ''
                          }`}
                        >
                          {isSelfOnboardingPage ? (
                            <div>
                              <AppButton
                                id="questionnaire-send-verification-link-button"
                                className={`primary no-border ${
                                  esignPages ? 'mobile-btn-fixed' : ''
                                }`}
                                disabled={isContinueButtonDisabled || uploading}
                                onClick={() => {
                                  handleOnboardingSubmit();
                                }}
                                label="Send Verification Link"
                                isProcessing={isOnboardingLoading}
                              />
                              <div className="text-center forgot-link-container">
                                <Typography
                                  variant="size-14"
                                  color="color-28"
                                  className="d-inline-block"
                                >
                                  Already have an account?&nbsp;{' '}
                                </Typography>
                                <Link to="/">
                                  <Typography
                                    variant="size-18"
                                    weight="bold"
                                    color="color-2"
                                    className="login-btn"
                                  >
                                    Login
                                  </Typography>
                                </Link>
                              </div>
                            </div>
                          ) : stripedPages.includes(currentPage?.unique_key) &&
                            stripeHasCard === false ? (
                            <AppButton
                              id="questionnaire-add-card-button"
                              className={`primary no-border ${
                                esignPages ? 'mobile-btn-fixed' : ''
                              }`}
                              disabled={
                                !isStripeCardFormValid || isStripeProcessing
                              }
                              onClick={() => {
                                stripePaymentRef.current?.submitCard();
                              }}
                              label="Add Card and Continue"
                              isProcessing={
                                questionnaireLoading || isStripeProcessing
                              }
                            />
                          ) : (
                            <AppButton
                              id="questionnaire-continue-button"
                              className={`${
                                isPracticeSummaryInfoPage
                                  ? 'btn-practice-info'
                                  : 'primary'
                              } no-border ${
                                esignPages ? 'mobile-btn-fixed' : ''
                              }`}
                              disabled={
                                uploading ||
                                (isProfilePicturePage
                                  ? !userHasProfilePicture
                                  : isContinueButtonDisabled) ||
                                (isFileTypeInvalid && true)
                              }
                              onClick={() => {
                                handleOnclick();
                              }}
                              label={buttonLabel}
                              isProcessing={
                                questionnaireLoading || isStripeProcessing
                              }
                            />
                          )}
                        </div>
                      )}

                  {(questionnaireProgress?.currentPageNumber > 1 ||
                    (loggedInUser?.metadata &&
                      loggedInUser?.metadata['opt-out-enable'] === 'true')) &&
                    shouldHideGoBackButton && (
                      <div className="go-back-button" onClick={goBack}>
                        <Typography
                          color="color-26"
                          variant="size-14"
                          weight="bold"
                        >
                          <FontAwesomeIcon icon={faArrowLeft} /> Go Back
                        </Typography>
                      </div>
                    )}
                </div>
              }
            </div>
          </div>
          <div>
            {' '}
            {questionnaireGroup?.type &&
            questionnaireGroup?.type ===
              QuestionnaireGroupType.SELF_MATCHING_CLIENT_INTAKE &&
            currentQuestions ? (
              <Logo />
            ) : (
              <>
                {poweredByI2ILogo && (
                  <div className="text-center powered-by-container">
                    <div className="poweredby_logo">
                      <img
                        src={`${decodeURIComponent(poweredByI2ILogo)}`}
                        alt="logo"
                        className="d-inline-block"
                      />
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
      {showLocationModal &&
        clientOnboardingModalOnboardingVisibility &&
        questionnaireGroup?.type ===
          QuestionnaireGroupType.SELF_MATCHING_CLIENT_INTAKE && (
          <ClientOnboardingModal
            handleContinueClick={handleOnclick}
            setIsMatchAssistance={setIsMatchAssistance}
          />
        )}
    </div>
  );
}
